"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Polygon = void 0;
const Point_1 = require("./Point");
class Polygon {
    constructor(p, parent) {
        this.layer = parseInt(p._attributes.layer);
        this.spacing = p._attributes.spacing ? parseFloat(p._attributes.spacing) : undefined;
        this.width = parseFloat(p._attributes.width);
        this.vertices = p.vertex.map((v) => new Point_1.Point(v._attributes.x, v._attributes.y));
        if (parent) {
            this.parentName = parent.name;
            this.vertices = this.vertices.map((v) => {
                v = v.rotate(parent.rotation);
                if (parent.mirrored) {
                    v.x = -v.x;
                }
                v.add(parent.point);
                return v;
            });
        }
    }
}
exports.Polygon = Polygon;
//# sourceMappingURL=Polygon.js.map